import { Theme, lighten } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const styles = {
    paceLandingLayoutStyles: makeStyles((theme: Theme) =>
        createStyles({
            welcomeTitle: {
                fontWeight: "bold",
                fontSize: 36,
                textTransform: "uppercase",
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(5),
            },
            boxWrapper: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                paddingLeft: theme.spacing(7),
                paddingRight: theme.spacing(6),
                backgroundColor: theme.palette.common.white,
            },
            aboutTextBox: {
                marginBottom: theme.spacing(3),
                "& .MuiTypography-root": {
                    fontSize: 14,
                    lineHeight: 1.25,
                },
                "& ul": {
                    paddingLeft: theme.spacing(5),
                    margin: 0,
                },
            },
            aboutSubBoxes: {
                display: "flex",
                flexWrap: "wrap",
                margin: theme.spacing(5, -3, 3),
                "& .MuiGrid-item": {
                    display: "flex",
                    padding: theme.spacing(0, 2),
                },
            },
            aboutSubBox: {
                backgroundColor: theme.palette.others.cyanLight,
                position: "relative",
                borderRadius: 16,
            },
            aboutSubBoxIcon: {
                display: "block",
                margin: "auto",
                marginTop: theme.spacing(-3),
                backgroundColor: "#D9EDFF",
                borderRadius: "50px",
                padding: theme.spacing(1),
            },
            aboutSubBoxText: {
                padding: theme.spacing(1, 2.5, 2),
            },
            buttonLink: {
                fontSize: "inherit",
                letterSpacing: "normal",
                fontWeight: 400,
                color: theme.palette.primary.main,
                marginLeft: theme.spacing(0.6),
                "& .MuiSvgIcon-root": {
                    fontSize: 12,
                },
            },
            startPaceButton: {
                display: "flex",
                margin: "auto",
                right: 18,
                transform: "translateY(25px)",
                backgroundColor: theme.palette.others.darkBlue,
                "& .MuiButton-label": {
                    textTransform: "uppercase",
                },
                "&:hover": {
                    backgroundColor: lighten(theme.palette.others.darkBlue, 0.1),
                    boxShadow: "0 7px 15px 3px rgba(45, 45, 68, 0.15)",
                },
            },
        })
    ),
};

export default styles;
